module.exports = __webpack_public_path__ + "img/AUR.59afcf36.svg";